import { QueueDashboardFavorite } from 'lib-dashboard-types';
import { useMemo } from 'react';

import { dashboardApi } from 'apis/dashboard';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { useCurrentUser } from 'utils/user';

type UseQueueDashboardFavoriteResult = {
  favorite: QueueDashboardFavorite | undefined;
  isOwnerOfFavorite: boolean;
};

/**
 * A hook that returns the information about the currently selected dashboard
 * favorite from the API cache, if any matches the current URL params.
 */
export const useQueueDashboardFavorite =
  (): UseQueueDashboardFavoriteResult => {
    const { user } = useCurrentUser();
    const { params } = useAppSearchParams('/dashboard/queues');

    const { favorite } =
      dashboardApi.endpoints.readDashboardFavorite.useQueryState(
        {
          id: params.type === 'favourite' && params.id ? params.id : '',
        },
        {
          skip: !(params.type === 'favourite' && params.id),
          selectFromResult: ({ data }) => ({
            favorite: data?.data.favorite,
          }),
        },
      );

    return useMemo(
      () => ({
        favorite,
        isOwnerOfFavorite: favorite?.user.id === user.id,
      }),
      [favorite, user.id],
    );
  };
